import { useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  RouteProps,
  Redirect,
} from "react-router-dom";
import { RootState } from "../app/store";
import NavbarScroller from "../components/Navbar";
import { privateNavigationLinks } from "./navigationLinks";

export const ProtectedRoute: React.FC<RouteProps> = ({
  component: Component,
  ...rest
}) => {
  const { isAuth } = useSelector((state: RootState) => state.user);
  if (!Component) {
    return null;
  }

  return (
    <>
      {/* <NavbarScroller links={privateNavigationLinks.links} /> */}
      <Route
        {...rest}
        render={(props) =>
          isAuth ? <Component {...props} /> : <Redirect to="/login" />
        }
      />
    </>
  );
};
